import BaseCheckBox from "Engine/base/ui/BaseCheckBox";
import {TweenMax, Linear} from "gsap";

export default class CheckBox extends BaseCheckBox {
    constructor(data, displayItemData) {
        super(data, displayItemData);

        this.incativeTintColor = 0xCCCCCC;

        this.init();
        //this.createTweens();
    }

    init() {
        super.init();
        /*this.image = this.getChildAt(1);
        this.image.pivot.set(this.image.width / 2, this.image.height / 2);
        this.image.x += this.image.width / 4;
        this.image.y += this.image.height / 4;*/
    }

    createTweens() {
        if(this.tween) {
            this.tween.kill();
        }
        this.tween = TweenMax.to(this.image.scale, 0.1, {x: '-=' + 0.1, y: '-=' + 0.1, ease:Linear.easeNone, yoyo:true, repeat:1, paused:true});
    }

    onClick() {
        super.onClick();
        this.tween.play(0);
    }

    goToFrame(frameId, force = false) {
        super.goToFrame(frameId, force);
        if (this.image !== this.getChildAt(1)) {
            this.image = this.getChildAt(1);
            this.image.pivot.set(this.image.width / 2, this.image.height / 2);
            this.image.x += this.image.width / 2;
            this.image.y += this.image.height / 2;
            this.createTweens();
        }
    }

    get enabled() {
        return this._enabled;
    }

    set enabled(value) {
        this._enabled = value;
        if (value) {
            this.interactive = true;
            this.buttonMode = true;
        } else {
            this.interactive = false;
            this.buttonMode = false;
        }

        this.children.forEach((child)=>{
            child.tint = this._enabled ? 16777215 : this.incativeTintColor;
        });
    }
}